var __decorate=this&&this.__decorate||function(e,t,o,r){var a,i=arguments.length,d=i<3?t:null===r?r=Object.getOwnPropertyDescriptor(t,o):r;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)d=Reflect.decorate(e,t,o,r);else for(var p=e.length-1;p>=0;p--)(a=e[p])&&(d=(i<3?a(d):i>3?a(t,o,d):a(t,o))||d);return i>3&&d&&Object.defineProperty(t,o,d),d};import{css as e,html as t}from"lit";import{OrElement as o}from"@openremote/or-element";import{customElement as r,property as a}from"lit/decorators.js";let OrLoadingWrapper=class extends o{constructor(){super(...arguments),this.loadDom=!0,this.fadeContent=!1,this.loading=!1}static get styles(){return e`
      :host {
        display: block;
      }

      .hidden {
        display: none;
      }

      .faded {
        opacity: 0.5;
      }

      #wrapper {
        position: relative;
      }

      #loader {
        position: absolute;
        width: 100%;
        height: 100%;
      }

      #content-wrapper {
        display: flex;
      }
    `}render(){return t`
      <div id="wrapper">
        ${this.loading?t`<div id="loader">LOADING</div>`:""}
        ${this.loadDom||!this.loading?t` <div id="content-wrapper" class="${this.loading?this.fadeContent?"faded":"hidden":""}">
                <slot></slot>
                ${this.content||""}
              </div>`:""}
      </div>
    `}};__decorate([a({type:Number})],OrLoadingWrapper.prototype,"loadingHeight",void 0),__decorate([a({type:Boolean})],OrLoadingWrapper.prototype,"loadDom",void 0),__decorate([a({type:Boolean})],OrLoadingWrapper.prototype,"fadeContent",void 0),__decorate([a({type:Boolean})],OrLoadingWrapper.prototype,"loading",void 0),__decorate([a({type:Object,attribute:!1})],OrLoadingWrapper.prototype,"content",void 0),OrLoadingWrapper=__decorate([r("or-loading-wrapper")],OrLoadingWrapper);export{OrLoadingWrapper};